export const isEmpty = (val) => {
  if (val === null) {
    return true;
  }

  if (typeof val === "string") {
    if (val.trim().length == 0) {
      return true;
    }
  }

  if (Array.isArray(val)) {
    if (val.length == 0) {
      return true;
    }
  }

  return false;
};

export const isEmail = (email) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};

export const objectToQueryString = function (obj) {
  var qs = "",
    property,
    value,
    isFirst = true;

  for (property in obj) {
    if (property) {
      value = obj[property];
      if (!isEmpty(value)) {
        if (isFirst) {
          isFirst = false;
        } else {
          qs += "&";
        }
        qs += property + "=" + encodeURIComponent(obj[property]);
      }
    }
  }
  return qs;
};

export const queryStringToObject = function (queryString) {
  var data = {},
    i = 0,
    pair = null,
    pairs = [];

  queryString =
    queryString.substring(0, 1) === "?" ? queryString.slice(1) : queryString;

  pairs = queryString.split("&");

  for (i = 0; i < pairs.length; i++) {
    pair = pairs[i];
    pair = pair.split("=");
    data[pair[0]] = decodeURIComponent(pair[1] || "");
  }

  return data;
};
